module.exports = __webpack_public_path__ + "static/media/Rectangle 68.7a3155eb.png";